import React from "react";
import { AttributeDefaultHeaderWrapper } from "./styles";
import AttributeInnerCard from "./AttributeInnerCard";
import { Ptag } from "components/core";

function AttributeCoPayment({ data }) {
  return (
    <div
      style={{
        display: "flex",
        gap: "24px",
      }}
    >
      {data?.esc && (data?.esc?.limit || data?.esc?.min || data?.esc?.max) && (
        <>
          <div>
            <Ptag fontSize="14px" fontWeight="600" marginBottom="18px">
              For Employee, Spouse and Children
            </Ptag>
            <AttributeDefaultHeaderWrapper>
              <AttributeInnerCard
                title={data?.esc?.min || data?.esc?.max ? "Default" : "Limit"}
                value={data?.esc?.limit}
                width="200px"
              />
              {data?.esc?.min && (
                <AttributeInnerCard
                  title="Minimum Limit"
                  value={data?.esc?.min}
                  width="200px"
                />
              )}
              {data?.esc?.max && (
                <AttributeInnerCard
                  title="Maximum Limit"
                  value={data?.esc?.max}
                  width="200px"
                />
              )}
            </AttributeDefaultHeaderWrapper>
          </div>
        </>
      )}
      {data?.parents && (data?.parents?.min || data?.parents?.max || data?.parents?.limit) && (
        <>
          <div>
            <Ptag
              fontSize="14px"
              fontWeight="600"
              marginBottom="18px"
            >
              For Parents
            </Ptag>
            <AttributeDefaultHeaderWrapper>
              <AttributeInnerCard
                title={
                  data?.parents?.min || data?.parents?.max ? "Default" : "Limit"
                }
                value={data?.parents?.limit}
                width="200px"
              />
              {data?.parents?.min && (
                <AttributeInnerCard
                  title="Minimum Limit"
                  value={data?.parents?.min}
                  width="200px"
                />
              )}
              {data?.parents?.max && (
                <AttributeInnerCard
                  title="Maximum Limit"
                  value={data?.parents?.max}
                  width="200px"
                />
              )}
            </AttributeDefaultHeaderWrapper>
          </div>
          <article>
            {data?.parents?.remarks && (
              <Ptag fontWeight="400" color="#4a4a4a" marginTop="18px">
                Remarks: {data?.parents?.remarks}
              </Ptag>
            )}
          </article>
        </>
      )}
    </div>
  );
}

export default AttributeCoPayment;
